<template lang="pug">

  .what-is-this-link-component
    a.form-link.info(href="#", @click.prevent="showModal = true") {{ $t('what_is_this.link') }}
    modal(v-if="showModal", @close="showModal = false")
      slot This is it

</template>

<script>
export default {
  name: 'what-is-this-link',

  data: () => ({
    showModal: false
  })
}
</script>
